const PAGE_AUTH_TYPES = {
  REQUIRED: 'required',

  OPTIONAL: 'optional',

  UNNECESSARY: 'unnecessary',
} as const;

export const PAGE_LIST = {
  /** ログイン */
  LOGIN: {
    pathname: () => '/login',
    authType: PAGE_AUTH_TYPES.UNNECESSARY,
    head: {
      title: '管理者ログイン',
      description: '',
    },
  },
  SETTING: {
    pathname: () => '/auth/settings',
    authType: PAGE_AUTH_TYPES.UNNECESSARY,
    head: {
      title: 'Setting',
      description: '',
    },
  },
  /** 充電ステーション */
  HOME: {
    pathname: () => '/',
    authType: PAGE_AUTH_TYPES.REQUIRED,
    head: {
      title: 'HOME',
      description: '',
    },
  },
} as const;
